import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { getProjectId } from "Libs/utils";

import type { DeploymentLocalDedicated } from "Api/organizations/projects/environments/deployments/types";
import type { AsyncThunkOptionType } from "Reducers/types";
import { getDeploymentLocalDedicatedRequest } from "Api/organizations/projects/environments/deployments/getDeploymentLocalDedicated.request";

type LoadDeploymentLocalDedicatedProps = {
  organizationId: string;
  projectId: string;
};

export const loadDeploymentLocalDedicated = createAsyncThunk<
  DeploymentLocalDedicated,
  LoadDeploymentLocalDedicatedProps,
  AsyncThunkOptionType
>(
  "app/environmentDeployment/localDedicated",
  async ({ projectId }, { getState, rejectWithValue }) => {
    try {
      const projectDescriptionId = getProjectId(getState, projectId)!;

      const deployment = await getDeploymentLocalDedicatedRequest({
        projectId: projectDescriptionId
      });

      return deployment;
    } catch (error) {
      const errorMessage =
        (error as { message?: string })?.message ??
        "An error occurred while attempting to load local dedicated deployment.";

      logger(errorMessage, {
        action: "load_deployment_local_dedicated"
      });

      return rejectWithValue(error as { code: number; message: string });
    }
  }
);
